import { i18nInstance } from "@/i18n";

function translatePassengerType(passengerType, count) {
    let passengerTypeString =
        count > 1 ? passengerType.namePlural : passengerType.nameSingular;

    return passengerTypeString[i18nInstance().locale];
}

export default {
    install: function(Vue) {
        Vue.filter("passengers", function(passengers) {
            const totalPassengers = passengers
                .map(passenger => {
                    return passenger.count;
                })
                .reduce(
                    (accumulator, currentValue) => accumulator + currentValue,
                    0
                );

            if (totalPassengers <= 0) {
                return i18nInstance().t("filter_passenger.choose_travellers");
            }

            return passengers
                .filter(passenger => {
                    return passenger.count > 0;
                })
                .map(passenger => {
                    return (
                        passenger.count +
                        " " +
                        translatePassengerType(
                            passenger.passengerType,
                            passenger.count
                        )
                    );
                })
                .reduce(
                    (accumulator, currentValue) =>
                        accumulator +
                        (accumulator.length > 0 ? ", " : "") +
                        currentValue,
                    ""
                );
        });
        Vue.filter("passenger", function(passengerType) {
            return passengerType[i18nInstance().locale];
        });
    }
};
